import React from "react";
import styled from "styled-components";
import ButtonComponent from "../../../../utils/button/ButtonComponent";
import Title from "../../../../utils/title/Title";
import { Colors } from "../../../../utils/colors/colors";
import { IHeaderType } from "../../../../types/types";
import { useModal } from "../../../../hooks/utils.hook";
import { MediumModal } from "../../../../utils/modals/Modal";
import OneKBInitiativeIntakeForm from "../../../../components/modal-contents/OneKBInitiativeIntakeForm";

type Props = {};

const AboutEratekDetails = (props: Props) => {
  const { open, openModal, closeModal } = useModal();

  const { secondaryColor, primaryColor, whiteColor } = Colors();

  return (
    <>
      <div>
        <TitleWrapper>
          <Title
            textColor={primaryColor}
            text={"About the"}
            style={{
              margin: 0,
              fontWeight: 700,
              fontSize: "40px",
            }}
            type={IHeaderType.h3}
          />

          <Title
            textColor={secondaryColor}
            text={"Eratek"}
            style={{
              margin: 0,
              fontWeight: 700,
              fontSize: "40px",
            }}
            type={IHeaderType.h3}
          />

          <Title
            textColor={primaryColor}
            text={"1KB Initiative"}
            style={{
              margin: 0,
              fontWeight: 700,
              fontSize: "40px",
            }}
            type={IHeaderType.h3}
          />
        </TitleWrapper>

        <Text
          data-aos="fade-up"
          data-aos-once="true"
        >
          In Africa, millions of businesses thrive in local communities, contributing immensely to the economy. But too often, they remain hidden, without the visibility or tools to grow in a digital world.{" "}
          <br />
          <br />
          The <i>Eratek 1KB Initiative</i> is built to change that. We aim to empower African businesses, offering a free, easy-to-use solution that makes them digitally accessible to more customers than ever before. Whether you're a small shop or a growing enterprise, our initiative helps you unlock the power of technology to expand your reach and build your future.
        </Text>
      </div>

      <ButtonComponent
        data-aos="fade-up"
        data-aos-once="true"
        bgColor={secondaryColor}
        text={"Get Started For Free"}
        click={openModal}
        isLoading={false}
        style={{
          color: whiteColor,
          maxWidth: "230px",
          marginTop: "30px",
        }}
      />

      <MediumModal
        open={open}
        showCloseIcon={false}
        openModal={openModal}
        closeModal={closeModal}
        children={<OneKBInitiativeIntakeForm closeModal={closeModal} />}
      />
    </>
  );
};

export default AboutEratekDetails;

const TitleWrapper = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const Text = styled.p`
  max-width: 623px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: #4f4f4f;
`;
